import {
    type ColDef,
    type ValueFormatterParams,
} from '@ag-grid-community/core';
import {
    defaultTextFilterParams,
    FilterType,
} from '@components/ICSGrid/config-filter';
import { type Component } from '@gql/graphql';

export const ComponentsTableColumns: ColDef<Component>[] = [
    {
        field: 'id',
        headerName: 'ID',
        filter: FilterType.Text,
        filterParams: {
            filterOptions: ['equals'],
        },
        sortable: false,
    },
    {
        field: 'name',
        headerName: 'Component',
        filter: FilterType.Text,
    },
    {
        field: 'version',
        headerName: 'Version',
        filter: FilterType.Text,
        filterParams: defaultTextFilterParams,
        floatingFilter: true,
        sortable: false,
    },
    {
        field: 'eolReached',
        headerName: 'EOL reached',
        filter: FilterType.Set,
        filterParams: {
            values: [true, false],
        },
        refData: {
            true: 'Yes',
            false: 'No',
        },
    },
    {
        field: 'componentVendor.name',
        headerName: 'Vendor',
        sortable: false,
        filter: FilterType.Text,
    },
    {
        field: 'monitoredSince',
        headerName: 'Monitored since',
        type: 'shortDate',
    },
    {
        field: 'createTime',
        headerName: 'Created',
        type: 'shortDate',
    },
    {
        field: 'updateTime',
        headerName: 'Last updated',
        type: 'shortDate',
    },
    {
        field: 'componentVendor.assessments',
        headerName: 'Has assessment',
        filter: false,
        sortable: false,
        valueFormatter: (params: ValueFormatterParams<Component>): string => {
            return params.data?.componentVendor.assessments?.find(Boolean)
                ? 'Yes'
                : 'No';
        },
    },
];
